// extracted by mini-css-extract-plugin
module.exports = {"edit-panel":"e8f26c48d43ea9ba1e894fd7c8720d7c-less","editPanel":"e8f26c48d43ea9ba1e894fd7c8720d7c-less","buttons":"_683f5f6fbac452570163ceb582846af4-less"};